import React from "react";

const KuwaitPccExp = () => {
  return (
    <div className="pccExpContainer">
      <h2>
        Detailed Explanation of the Kuwait <span>PCC</span> Verification
        Procedure
      </h2>
      <p>
        To provide a thorough understanding, here’s a detailed explanation of
        each step in the Kuwait PCC verification process:
      </p>
      <ul>
        <li>
          <h3>
            <span>1. </span> Application Submission:
          </h3>{" "}
          Submit the PCC application along with required documents to the local
          police department or relevant authority.
        </li>
        <li>
          <h3>
            <span>2. </span> Background Check:
          </h3>{" "}
          The police conduct a comprehensive background check to verify the
          applicant’s criminal record and personal details.
        </li>
        <li>
          <h3>
            <span>3. </span> Issuance of PCC:
          </h3>{" "}
          Upon successful verification, the police issue the PCC certifying that
          the applicant has no criminal history.
        </li>
        <li>
          <h3>
            {" "}
            <span>4. </span>State Home Department Attestation
          </h3>{" "}
          The PCC is attested by the State Home Department to authenticate its
          validity within the state.
        </li>
        <li>
          <h3>
            {" "}
            <span>5. </span>MEA Attestation:
          </h3>{" "}
          The document undergoes attestation by the Ministry of External Affairs
          to confirm its authenticity for international use.
        </li>
        <li>
          <h3>
            {" "}
            <span>6. </span>Embassy Attestation:
          </h3>{" "}
          The final step involves attesting the PCC at the Kuwait Embassy in
          India, ensuring recognition and acceptance by Kuwaiti authorities.
        </li>
      </ul>
    </div>
  );
};

export default KuwaitPccExp;
